/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q3Inputs */

const et_faq_q3 = /** @type {(inputs: Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miks mu ilus koduleht ei too päringuid?`)
};

const en_faq_q3 = /** @type {(inputs: Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why doesn't my beautiful website generate inquiries?`)
};

/**
* | output |
* | --- |
* | "Why doesn't my beautiful website generate inquiries?" |
*
* @param {Faq_Q3Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q3 = /** @type {((inputs?: Faq_Q3Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q3Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q3(inputs)
	return en_faq_q3(inputs)
});